import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { ScanPointService } from "../services/scanpoint.service";
import { AddHallPassReasonComponent } from "./add-hall-pass-reason/add-hall-pass-reason.component";
import { EditHallPassReasonComponent } from "./edit-hall-pass-reason/edit-hall-pass-reason.component";
import { SavePreferenceRequest } from "../services/SavePreferenceRequest";

@Component({
	selector: "caass-scanpoint-scan-point-config",
	templateUrl: "./scan-point-config.component.html",
	styleUrls: ["./scan-point-config.component.css"],
})
export class ScanPointConfigComponent implements OnInit {
	constructor(
		private scanService: ScanPointService,
		private userService: UserService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
		//Load Data From DB

		//Get prefrences
		this.loadPreferences();

		//Load data, and select the selcted values
		//this.loadFacilityList(-1);
		//this.loadReceiptPrinterList(-1);
	}

	//////////////////////
	// Data
	//////////////////////

	user: any;
	errorMessage: any = "";

	//Input Data
	SelectedFacilityID: any = 0;
	SelectedFacilityLocationID: any = 0;
	SelectedPrinterID: any = 0;
	IsAsyncScan: any = false;

	lstFacilities: any = [];
	lstFacilityLocations: any = [];
	lstPrinters: any = [];

	//Table Data
	HallPassRawData: any = [];
	lstHallPassReasons: any = [];
	pagerows: any = 10;
	pagefirst: any = 0;
	SelectedReason: any = null;
	cols = [
		{ field: "ReasonDesc", header: "Reason Description" },
		{ field: "Level", header: "Level" },
		{ field: "DefinedBy", header: "Defined By" },
	];

	//Filter Lists
	lstLevel: any = [];
	lstDefinedBy: any = [];

	lstPrefs: any = [];

	NormalScanSound: any; // = "Single_Ding.mp3";
	InvalidScanSound: any; // = "Alarm.mp3";
	lstNormalSound: any = [];
	lstInvalidSound: any = [];

	PreferenceLoading: boolean = false;
	FacilityLoading: boolean = false;
	//////////////////////

	//////////////////////
	// Load Data
	//////////////////////
	loadPreferences() {
		this.PreferenceLoading = true;

		var result = this.scanService.loadSPPreferences(this.user.personID);
		result.subscribe(
			(response) => {
				this.PreferenceLoading = false;

				this.lstPrefs = response;
				this.UpdatePreferences();
			},
			(error) => {
				this.PreferenceLoading = false;
			}
		);
	}

	UpdatePreferences() {
		var fID: any = -1; //FacilityID
		var flID: any = -1; //Facility Location ID
		var pID: any = -1; //Printer ID
		var async: any = false; //Async checked

		for (var i = 0; i < this.lstPrefs.length; i++) {
			var next = this.lstPrefs[i];

			if (next.KeyName == "FacilityID") {
				fID = Number(next.KeyValue);
			} else if (next.KeyName == "FacilityLocationID") {
				flID = Number(next.KeyValue);
			} else if (next.KeyName == "IsAsyncScan") {
				async = next.KeyValue == 1 ? true : false;
			} else if (next.KeyName == "Receipt_IDPrinterID") {
				pID = Number(next.KeyValue);
			}
		}

		this.IsAsyncScan = async;
		this.loadFacilityList(fID, flID, pID);
		this.loadSoundList();
		//this.loadReceiptPrinterList(pID);
	}

	loadFacilityList(FacVal, LocationVal, printerVal) {
		this.FacilityLoading = true;

		var result = this.scanService.loadFacilityList("", this.user.userID);
		result.subscribe(
			(response) => {
				this.FacilityLoading = false;

				this.lstFacilities = response;

				this.SelectedFacilityID = this.lstFacilities[0].FacilityID;

				if (FacVal >= 0) {
					this.SelectedFacilityID = FacVal;
				}

				//Init Data
				this.loadFacilityLocationList(LocationVal);
				this.loadReceiptPrinterList(printerVal);
				this.loadHallpassReasonList();
			},
			(error) => {
				this.FacilityLoading = false;
			}
		);
	}

	loadFacilityLocationList(val) {
		var result = this.scanService.loadFacilityLocationList("", this.SelectedFacilityID);
		result.subscribe(
			(response) => {
				this.lstFacilityLocations = response;

				this.lstFacilityLocations.unshift({
					FacilityLocationID: -1,
					FacilityLocationName: "N/A",
				});

				this.SelectedFacilityLocationID = this.lstFacilityLocations[0].FacilityLocationID;

				if (val >= 0) {
					this.SelectedFacilityLocationID = val;
				}
			},
			(error) => {}
		);
	}

	loadReceiptPrinterList(val) {
		var result = this.scanService.loadReceiptPrinterList("", this.SelectedFacilityID);
		result.subscribe(
			(response) => {
				this.lstPrinters = response;

				this.lstPrinters.unshift({
					IDPrinterID: -1,
					Name: "N/A",
				});

				this.SelectedPrinterID = this.lstPrinters[0].IDPrinterID;

				if (val >= 0) {
					this.SelectedPrinterID = val;
				}
			},
			(error) => {}
		);
	}

	loadHallpassReasonList() {
		var result = this.scanService.loadHallpassReasonList("", this.SelectedFacilityID);
		result.subscribe(
			(response) => {
				this.HallPassRawData = response;

				this.UpdateHPRTableData();
			},
			(error) => {}
		);
	}

	loadSoundList() {
		var result = this.scanService.loadSoundLibraryList(this.SelectedFacilityID);
		result.subscribe(
			(response) => {
				this.lstNormalSound = response;
				this.lstInvalidSound = response;

				var ValidPref: string = "Single_Ding.mp3";
				var InvalidPref: string = "Alarm.mp3";

				for (var z = 0; z < this.lstPrefs.length; z++) {
					var next = this.lstPrefs[z];

					if (next.KeyName == "NormalScanSound") {
						ValidPref = next.KeyValue;
					}
					if (next.KeyName == "InvalidScanSound") {
						InvalidPref = next.KeyValue;
					}
				}

				for (var z = 0; z < this.lstNormalSound.length; z++) {
					var next = this.lstNormalSound[z];

					if (next.SoundFile == ValidPref) {
						this.NormalScanSound = next;
					}
				}

				for (var z = 0; z < this.lstInvalidSound.length; z++) {
					var next = this.lstInvalidSound[z];

					if (next.SoundFile == InvalidPref) {
						this.InvalidScanSound = next;
					}
				}
			},
			(error) => {}
		);
	}

	UpdateHPRTableData() {
		//ReasonDesc
		//Level
		//DefinedBy

		this.lstHallPassReasons = [];

		//Filter
		this.lstLevel = [];
		this.lstDefinedBy = [];

		for (var i = 0; i < this.HallPassRawData.length; i++) {
			var next = this.HallPassRawData[i];
			var lvl = next.FacilityID == 0 ? "District" : "School";

			let val1: any = {
				ReasonID: next.HallpassReasonID,
				ReasonDesc: next.HallpassReasonDesc,
				Level: lvl,
				DefinedBy: next.DefinedByDesc,
			};

			this.lstHallPassReasons = [...this.lstHallPassReasons, val1];

			var levelFound = false;
			for (var j = 0; j < this.lstLevel.length; j++) {
				if (this.lstLevel[j] == lvl) {
					levelFound = true;
				}
			}

			if (!levelFound) {
				this.lstLevel = [...this.lstLevel, lvl];
			}

			var dbFound = false;
			for (var j = 0; j < this.lstDefinedBy.length; j++) {
				if (this.lstDefinedBy[j] == next.DefinedByDesc) {
					dbFound = true;
				}
			}

			if (!dbFound) {
				this.lstDefinedBy = [...this.lstDefinedBy, next.DefinedByDesc];
			}
		}
	}

	//////////////////////

	//////////////////////
	// Buttons
	//////////////////////
	onAdd() {
		this.errorMessage = "";

		//Create Popup
		var ref = this.dialogService.open(AddHallPassReasonComponent, {
			header: "Add Hall Pass Reason",
			width: "fit-content",
			data: {
				User: this.user,
				FacilityID: this.SelectedFacilityID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadHallpassReasonList();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedReason == null) {
			this.errorMessage = "Select a Hall Pass Reason to Edit";
			return;
		}

		//Create Popup
		var ref = this.dialogService.open(EditHallPassReasonComponent, {
			header: "Edit Hall Pass Reason",
			width: "fit-content",
			data: {
				User: this.user,
				FacilityID: this.SelectedFacilityID,
				//Selected Hall pass
				SelectedReason: this.SelectedReason,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadHallpassReasonList();
			}
		});
	}

	onDelete() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedReason == null) {
			this.errorMessage = "Select a Hall Pass Reason to Delete";
			return;
		}

		var result = this.scanService.DeleteHallPassReason("", this.SelectedReason.ReasonID);
		result.subscribe(
			(response) => {
				this.SelectedReason = null;
				this.loadHallpassReasonList();
			},
			(error) => {}
		);
	}

	onSave() {
		var parms: SavePreferenceRequest = {
			PersonID: this.user.personID,
			IsAsyncScan: this.IsAsyncScan == true ? 1 : 0,
			FacilityID: this.SelectedFacilityID,
			FacilityLocationID: this.SelectedFacilityLocationID,
			PrinterID: this.SelectedPrinterID,
			NormalScanSound: this.NormalScanSound.SoundFile,
			InvalidScanSound: this.InvalidScanSound.SoundFile,
		};

		var result = this.scanService.SavePreferences(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "ScanPoint Settings were Successfully Updated",
						header: "ScanPoint Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update ScanPoint Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onReset() {
		this.loadPreferences();
	}
	//////////////////////

	//////////////////////
	// Events
	//////////////////////

	onFacilityChange(val) {
		this.SelectedFacilityID = val;

		this.loadFacilityLocationList(-1);
		this.loadReceiptPrinterList(-1);
		this.loadHallpassReasonList();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
		this.SelectedReason = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";
		this.SelectedReason = null;
	}
}
